module.exports = __webpack_public_path__ + "static/media/close-icon.ac18722e.svg";